function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { NoImageIcon } from '../Icons';
import { ErrorIcon, Img, ImgWrapper } from './style';
import { getSizePoint } from '../../utils/imageUtils';
var SmartImage = function SmartImage(_ref) {
  var id = _ref.id,
    alt = _ref.alt,
    src = _ref.src,
    ratio = _ref.ratio,
    position = _ref.position,
    _ref$width = _ref.width,
    width = _ref$width === void 0 ? 0 : _ref$width,
    _ref$sizedSrcList = _ref.sizedSrcList,
    sizedSrcList = _ref$sizedSrcList === void 0 ? [] : _ref$sizedSrcList;
  var wrapperRef = React.useRef(null);
  var _useState = useState(width),
    _useState2 = _slicedToArray(_useState, 2),
    wrapperWidth = _useState2[0],
    setWrapperWidth = _useState2[1];
  var _useState3 = useState(src),
    _useState4 = _slicedToArray(_useState3, 2),
    sizedUrl = _useState4[0],
    setSizedUrl = _useState4[1];
  var _useState5 = useState(!src && !sizedSrcList.length),
    _useState6 = _slicedToArray(_useState5, 2),
    fallbackImageVisible = _useState6[0],
    setFallbackImageVisible = _useState6[1];
  useEffect(function () {
    if (!width) {
      if (wrapperRef && wrapperRef.current) {
        var refRect = wrapperRef.current.getBoundingClientRect();
        setWrapperWidth(Math.floor(refRect.width));
      } else {
        setWrapperWidth(0);
      }
    }
  }, [width]);
  useEffect(function () {
    // TODO: Replace with 'Optional Chaining' after update to ES2020
    if (wrapperWidth && sizedSrcList.length) {
      var sizePoint = getSizePoint(wrapperWidth, sizedSrcList);
      if (sizePoint) {
        setSizedUrl(sizePoint.url);
      }
    }
  }, [sizedSrcList, wrapperWidth]);
  var onLoadError = function onLoadError() {
    setFallbackImageVisible(true);
  };
  if (fallbackImageVisible) {
    return /*#__PURE__*/React.createElement(ErrorIcon, {
      as: NoImageIcon
    });
  }
  if (sizedSrcList && sizedSrcList.length) {
    return /*#__PURE__*/React.createElement(ImgWrapper, {
      ref: wrapperRef
    }, wrapperWidth ? /*#__PURE__*/React.createElement(Img, {
      id: id,
      "data-testid": id,
      alt: alt,
      src: sizedUrl,
      ratio: ratio,
      position: position,
      onError: onLoadError
    }) : null);
  }
  return /*#__PURE__*/React.createElement(Img, {
    id: id,
    "data-testid": id,
    alt: alt,
    src: src,
    ratio: ratio,
    position: position,
    onError: onLoadError
  });
};

// @ts-ignore
SmartImage.propTypes = {
  id: PropTypes.string,
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  ratio: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.number,
  position: PropTypes.string,
  sizedSrcList: PropTypes.arrayOf(PropTypes.shape({
    size: PropTypes.number,
    url: PropTypes.string,
    type: PropTypes.string
  }))
};
SmartImage.defaultProps = {
  id: 'smartImage',
  alt: '',
  ratio: '',
  position: '',
  width: 0,
  sizedSrcList: []
};
export default SmartImage;